import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { AlertsWidget } from './Widgets';

@observer
class Widget extends React.Component<any> {
    public getWidgetContent = (widgetName: string) => {
        switch (widgetName) {
            case ('testWidget'): {
                return <div>test widget</div>
            }
            case ('testWidget2'): {
                return <div>test widget2</div>
            }
            case ('AlertsWidget'): {
                return <AlertsWidget />
            }
            default: {
                return <div>default widget</div>
            }
        }
    }
    public render() {
        const { widget_name } = this.props;

        return (
            <Paper style={{ width: "100%", height: "100%", overflow: 'auto' }}>
                {this.getWidgetContent(widget_name)}
            </Paper>
        );
    }
}

export default (
    withRouter(Widget)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widget.tsx